<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_CATEGORIES)"
          true
          :link="{
            name: $t('COMMON.CATEGORIES'),
            icon: 'fa fa-layer-group text-primary',
            path: '/inventory/categories',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_PRODUCTS)"
          true
          :link="{
            name: $t('COMMON.PRODUCTS'),
            icon: 'fa fa-cubes text-primary',
            path: '/inventory/products',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_STOCK_MOVEMENTS)"
          true
          :link="{
            name: $t('COMMON.STOCK_MOVEMENTS'),
            icon: 'fa fa-truck text-primary',
            path: '/inventory/stock-movements',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_ESTABLISHMENT_TRANSFERS)"
          true
          :link="{
            name: $t('COMMON.TRANSFERS'),
            icon: 'fa fa-exchange-alt text-primary',
            path: '/inventory/establishment-transfers',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_ESTABLISHMENT_INTERNAL_INVOICES)"
          true
          :link="{
            name: $t('COMMON.INTERNAL_INVOICES'),
            icon: 'fa fa-file-invoice-dollar text-primary',
            path: '/inventory/establishment-internal-invoices',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_ESTABLISHMENT_INTERNAL_ORDERS)"
          true
          :link="{
            name: $t('ESTABLISHMENT_INTERNAL_ORDERS.INTERNAL_ORDERS_MENU'),
            icon: 'fa fa-calendar-week text-primary',
            path: '/inventory/establishment-internal-orders',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_WAREHOUSES)"
          true
          :link="{
            name: $t('COMMON.WAREHOUSES'),
            icon: 'fa fa-2x fa-building text-primary',
            path: '/inventory/warehouses',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="inventoryHelpFiles.length > 0"
          true
          :link="{
            name: $t('TRAININGS.TRAININGS'),
            icon: 'fa fa-graduation-cap text-primary',
            path: '/inventory/training',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_SUPPLY_RULES)"
          true
          :link="{
            name: $t('COMMON.SUPPLY_RULES'),
            icon: 'fas fa-truck-moving text-primary',
            path: '/inventory/supply-rules',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_PRODUCTS)"
          true
          :link="{
            name: $t('COMMON.UNIT_OF_MEASURES'),
            icon: 'fa fa-layer-group text-primary',
            path: '/inventory/unit-of-measures',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_CATEGORY_EQUIPMENTS)"
          true
          :link="{
            name: $t('COMMON.CATEGORY_EQUIPMENTS'),
            icon: 'fa fa-2x fa-tag text-primary',
            path: '/inventory/category-equipments',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_EQUIPMENTS)"
          true
          :link="{
            name: $t('COMMON.EQUIPMENTS'),
            icon: 'fa  fa-wrench text-primary',
            path: '/inventory/equipments',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_EQUIPMENT_TRANSFERS)"
          true
          :link="{
            name: $t('EQUIPMENT_TRANSFERS.MENU_TITLE'),
            icon: 'fa fa-dolly text-primary',
            path: '/inventory/equipment-transfers',
          }"
        >
        </sidebar-item>
        <hr
          class="my-3"
          style="
            border-color: rgba(0, 0, 0, 0.1) currentcolor currentcolor;
            border-style: solid none none;
            border-width: 1px 0px 0px;
            border-image: none 100% / 1 / 0 stretch;
            min-width: 80%;
            overflow: visible;
            box-sizing: content-box;
            height: 0px;
          "
        />

        <lang-switcher />
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar
        :type="$route.meta.navbarType"
        :appModuleIcon="'ni ni-2x ni-app'"
        :appModuleName="$t('APPS.INVENTORY_MODULE')"
      ></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import moduleLayoutMixin from "@/mixins/module-layout-mixin";
import { LangSwitcher } from "@/components";
import DashboardNavbar from "../../Layouts/Authenticated/DashboardNavbar.vue";
import ContentFooter from "../../Layouts/Authenticated/ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import { HELP_CONTEXT_INVENTORY } from "@/constants/helpContexts";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
    LangSwitcher,
  },
  mixins: [moduleLayoutMixin],

  data() {
    return {};
  },

  methods: {},

  created() {
    // The « Formation » entry shows once the inventory help has files.
    this.$store
      .dispatch("trainings/helpForContext", { context: HELP_CONTEXT_INVENTORY })
      .catch(() => {});
  },

  async mounted() {},

  computed: {
    inventoryHelpFiles() {
      return this.$store.getters["trainings/helpForContext"](
        HELP_CONTEXT_INVENTORY
      );
    },
  },

  watch: {},
};
</script>
